// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// normalize CSS across browsers
import "./src/css/normalize.css"

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

// custom CSS styles
import "./src/css/style.css"
import "./src/css/general-css.css"

import React from 'react';

import MaintenanceChecker from './src/components/MaintenanceChecker'

const SUPPORTED = ["en", "de"];   // add more if you have them
const DEFAULT_LANG = "en";        // your default (often un-prefixed)

function getLangFromPath() {
    const parts = (window.location.pathname || "/").split("/").filter(Boolean);
    const first = parts[0];                   // e.g. "de" for /de/...
    return SUPPORTED.includes(first) ? first : DEFAULT_LANG;
}

const TEXTS = {
    en: {
        showContentLabel: "Show content",
        rememberChoiceLabel: "Remember choice",
        privacyPolicyLabel: "Privacy Policy",
        privacyPolicyUrl: "/en/privacy-policy",
        CustomTypes: [
            {
                type: "video",
                description:
                    "To activate the video, please click on the link. Enabling embedded videos will transmit data to the respective provider. Further information can be found in our privacy policy. <br />",
            },
            {
                type: "map",
                description:
                    "To view this map, click below. Enabling embedded maps may send data to the provider. See our privacy policy for details.<br />",
            },
            {
                type: "calendar",
                description:
                    "To view this calendar, click below. Enabling embedded calendars may send data to the provider. See our privacy policy for details.<br />",
            },
        ],
    },
    de: {
        showContentLabel: "Inhalt anzeigen",
        rememberChoiceLabel: "Auswahl merken",
        privacyPolicyLabel: "Datenschutzerklärung",
        privacyPolicyUrl: "/de/datenschutzerklaerung",
        CustomTypes: [
            {
                type: "video",
                description:
                    "Zum Abspielen des Videos bitte unten klicken. Durch das Aktivieren werden Daten an den Anbieter übermittelt. Weitere Infos in unserer Datenschutzerklärung.<br />",
            },
            {
                type: "map",
                description:
                    "Zum Anzeigen der Karte bitte unten klicken. Durch das Aktivieren werden Daten an den Anbieter übermittelt. Weitere Infos in unserer Datenschutzerklärung.<br />",
            },
            {
                type: "calendar",
                description:
                    "Zum Anzeigen des Kalenders bitte unten klicken. Durch das Aktivieren werden Daten an den Anbieter übermittelt. Weitere Infos in unserer Datenschutzerklärung.<br />",
            },
        ],
    },
};

export const wrapPageElement = ({ element }) => {
    return <MaintenanceChecker>{element}</MaintenanceChecker>;
};

console.log('browser');


export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
}) => {
    const { hash } = location;
    const currentPosition = getSavedScrollPosition(location);

    setTimeout(() => {
        if (hash) {
            const id = hash.substring(1); // Get id from hash, remove `#`
            const element = document.getElementById(id);

            if (element) {
                element.scrollIntoView();
            } else {
                window.scrollTo(...(currentPosition || [0, 0]));
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, 0);

    return false;
};


// Track if 2Click has been initialized to prevent multiple initializations
let is2ClickInitialized = false;

// Initialize 2ClickIframePrivacy (only once)
function initialize2Click() {
    if (typeof window === "undefined") return;
    if (is2ClickInitialized) return; // Prevent multiple initializations
    
    const lib = window._2ClickIframePrivacy;
    if (!lib || typeof lib.init !== "function") return;

    const lang = getLangFromPath();
    const t = TEXTS[lang] || TEXTS[DEFAULT_LANG];

    try {
        lib.init({
            enableCookies: true,
            useSessionCookie: false,
            cookieNamespace: "_2ClickIPEnable-",
            showContentLabel: t.showContentLabel,
            rememberChoiceLabel: t.rememberChoiceLabel,
            privacyPolicyLabel: t.privacyPolicyLabel,
            privacyPolicyUrl: t.privacyPolicyUrl,
            CustomTypes: t.CustomTypes,
        });
        is2ClickInitialized = true; // Mark as initialized
    } catch (error) {
        console.error("Error initializing 2ClickIframePrivacy:", error);
    }
}

// Wait for Cookiebot to be ready, then initialize 2Click
function waitForCookiebotAndInit() {
    if (typeof window === "undefined") return;
    
    // If Cookiebot is already ready
    if (window.Cookiebot && window.Cookiebot.consent) {
        // Wait a bit for Cookiebot to finish processing, then init
        setTimeout(() => {
            initialize2Click();
        }, 500);
        return;
    }
    
    // Wait for CookiebotOnConsentReady event (fires when Cookiebot is fully ready)
    const handleConsentReady = () => {
        // Wait for Cookiebot to finish processing blocked content
        setTimeout(() => {
            initialize2Click();
        }, 500);
    };
    
    window.addEventListener("CookiebotOnConsentReady", handleConsentReady, { once: true });
}

export const onInitialClientRender = () => {
    window.scrollTo(0, 0);
    
    // Wait for Cookiebot before initializing 2Click
    waitForCookiebotAndInit();
};

export const onRouteUpdate = () => {
    window.scrollTo(0, 0);

    if (typeof window === "undefined") return;
    
    // Reset initialization flag on route change so it can re-initialize for new page
    is2ClickInitialized = false;
    
    // Wait for Cookiebot before initializing 2Click
    waitForCookiebotAndInit();
};

